import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import {
    Box,
    Avatar,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    Typography,
    Divider
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

import avatar8 from './../../assets/images/avatar.jpg';
import AuthService from '../../services/auth.service';

/**
 * Menú de usuario del header (avatar + cerrar sesión)
 */
export default function AppHeaderDropdown({ compacto = false }) {
    const [user, setUser] = useState(AuthService.getCurrentUser());
    const [anchorEl, setAnchorEl] = useState(null);

    const handleLogout = () => {
        setAnchorEl(null);
        AuthService.logout();
        setUser(AuthService.getCurrentUser());
    };

    if (!user) {
        return <Navigate to="/login" replace={true} />;
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
                size="small"
                title={user.username}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={compacto ? { p: 0.25 } : undefined}
            >
                <Avatar src={avatar8} sx={{ width: compacto ? 26 : 36, height: compacto ? 26 : 36 }} />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                        minWidth: 180,
                    }
                }}
            >
                <Box sx={{ px: 2, py: 1, backgroundColor: '#f8f9fa' }}>
                    <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#212529' }}>
                        {user.username}
                    </Typography>
                </Box>
                <Divider />
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" sx={{ color: '#cc071e' }} />
                    </ListItemIcon>
                    Cerrar sesión
                </MenuItem>
            </Menu>
        </Box>
    );
}
